import { graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';
import * as React from 'react';

import PrimaryLayout from '../layouts/PrimaryLayout';
import PageIntro from '../components/layout/PageIntro';
import { IPrismicComponentNode, IPageDataItems } from '../components/utils/declarations';
import usePageData from '../components/hooks/usePageData';
import CategoryCards from '../components/modules/CategoryCards';

interface IWebCategoryTemplateProps {
  data: {
    prismic: {
      allWeb_categoriess: {
        edges: [
          {
            node: {
              _meta: {
                uid: string;
              };
              intro: string;
              title: string;
            };
          },
        ];
      };
      allWebs: {
        edges: [
          {
            node: IPrismicComponentNode;
          },
        ];
      };
    };
  };
}

const WebCategoryTemplate: React.FunctionComponent<IWebCategoryTemplateProps> = ({ data }) => {
  // Required check for no data being returned
  const doc = data.prismic.allWeb_categoriess.edges.slice(0, 1).pop();
  if (!doc) {
    return null;
  }

  const { title, intro } = doc.node;
  const { uid } = doc.node._meta;
  const slug = `/web/components/${uid}/`;
  const pageTitle = title && RichText.asText(title);
  const children: IPageDataItems[] = usePageData({ type: 'tree', slug });

  return (
    <PrimaryLayout title={pageTitle || 'Prismic Preview'} path={slug}>
      <PageIntro
        title={pageTitle || 'Prismic Preview'}
        intro={intro ? RichText.asText(intro) : undefined}
        path={slug}
      />
      <CategoryCards cardItems={children} />
    </PrimaryLayout>
  );
};

export default WebCategoryTemplate;

export const query = graphql`
  query WebCategoryTemplateQuery($uid: String) {
    prismic {
      allWeb_categoriess(uid: $uid) {
        edges {
          node {
            _meta {
              uid
            }
            intro
            title
          }
        }
      }
      allWebs {
        edges {
          node {
            title
            intro
            _meta {
              uid
              tags
            }
          }
        }
      }
    }
  }
`;
